import { observer } from 'inferno-mobx';
import { h } from 'inferno-hyperscript';
import { Component } from 'inferno';
import { set } from 'mobx';
import STATE from '../app/state.js';

const lsts = [
    'Blekinge län',
    'Dalarnas län',
    'Gävleborgs län',
    'Gamla SMHI-dammregister',
    'Gotlands län',
    'Hallands län',
    'Jämtlands län',
    'Jönköpings län',
    'Kalmar län',
    'Kronobergs län',
    'Örebro län',
    'Östergötlands län',
    'Norrbottens län',
    'Södermanlands län',
    'Skånes län',
    'Stockholms län',
    'Uppsala län',
    'Värmlands län',
    'Västerbottens län',
    'Västernorrlands län',
    'Västmanlands län',
    'Västra Götalands län'
];

const ModeSwitcher = observer(() => {
    const mode = STATE.mode;
    
    function change(evt) {
        STATE.mode = evt.target.value;
    }
    
    return h('ul', [
        h('li', [
            h('label', [
                h('input', { type: 'radio', name: 'mode', value: 'lake', checked: mode === 'lake', onChange: change }),
                'Sjöregister'
            ])
        ]),
        h('li', [
            h('label', [
                h('input', { type: 'radio', name: 'mode', value: 'dam', checked: mode === 'dam', onChange: change }),
                'Dammregister'
            ])
        ])
    ])
});

const LakeMapsComponent = observer((props) => {
    const showLakeMaps = STATE.showLakeMaps;
    
    function change(evt) {
        STATE.showLakeMaps = evt.target.checked;
    }
    
    return h('label', { className: !props.visible ? 'hide' : '' }, [
        h('input', { type: 'checkbox', onChange: change, checked: showLakeMaps }),
        'Visa sjöar med nedladdningsbara kartor'
    ]);
});

function IntervalComponent(props) {
    return h('fieldset.interval', [
        h('legend', props.legend),
        h('label', [
            'Från',
            h('input', {
                name: 'from',
                type: 'number',
                step: (props.step || [])[0],
                min: (props.min || [])[0],
                placeholder: (props.placeholder || [])[0] || '',
                value: props.from || '',
                onInput: props.change
            })
        ]),
        h('label', [
            'Till',
            h('input', {
                name: 'to',
                type: 'number',
                step: (props.step || [])[1],
                min: (props.min || [])[1],
                placeholder: (props.placeholder || [])[1] || '',
                value: props.to || '',
                onInput: props.change
            })
        ])
    ]);
}

class DamFilterComponent extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            county: undefined,
            surfaceArea: {
                from: undefined,
                to: undefined
            },
            volume: {
                from: undefined,
                to: undefined
            },
            year: {
                from: undefined,
                to: undefined
            },
            includeMissingValues: true
        };
        
        this.changeSurfaceArea = this.changeSurfaceArea.bind(this);
        this.changeVolume = this.changeVolume.bind(this);
        this.changeCounty = this.changeCounty.bind(this);
        this.changeYear = this.changeYear.bind(this);
    }
    
    change(key, evt) {
        const neu = {};
        // neu[evt.target.name] = parseFloat(evt.target.value);
        neu[evt.target.name] = evt.target.value;
        const newState = {};
        newState[key] = Object.assign(this.state[key], neu);
        this.setState(newState);
    }
    
    changeSurfaceArea(evt) {
        this.change('surfaceArea', evt);
    }
    changeVolume(evt) {
        this.change('volume', evt);
    }
    changeYear(evt) {
        this.change('year', evt);
    }
    
    changeCounty(evt) {
        const val = evt.target.selectedOptions[0].value;
        this.setState({
            county: val === 'undefined' ? undefined : val
        });
    }
    
    render() {
        return h('form.mode-options', {
            className: !this.props.visible ? 'hide' : '',
            onSubmit: evt => {
                evt.preventDefault();
                set(STATE, {
                    damFilter: {
                        county: this.state.county,
                        includeMissingValues: this.state.includeMissingValues,
                        volume: {
                            from: parseFloat(this.state.volume.from),
                            to: parseFloat(this.state.volume.to)
                        },
                        surfaceArea: {
                            from: parseFloat(this.state.surfaceArea.from),
                            to: parseFloat(this.state.surfaceArea.to)
                        },
                        year: {
                            from: parseFloat(this.state.year.from),
                            to: parseFloat(this.state.year.to)
                        }
                    }
                });
            }
        }, [
            h('label', [
                'Inrapporterande länsstyrelse',
                h('select', { onChange: this.changeCounty }, [
                    h('option', { selected: this.state.county === undefined }, 'Alla länsstyrelser'),
                    lsts.map(lst => h('option', {
                        value: lst,
                        selected: this.state.county === lst
                    }, lst))
                ])
            ]),
            h(IntervalComponent, Object.assign({}, this.state.surfaceArea, { 
                change: this.changeSurfaceArea,
                step: [0.001, 0.001],
                min: [0, 0],
                legend: 'Magasinsyta (km²)'
            })),
            h(IntervalComponent, Object.assign({}, this.state.volume, {
                change: this.changeVolume,
                step: [0.001, 0.001],
                min: [0, 0],
                legend: 'Regleringsvolym (miljoner m³)'
            })),
            h(IntervalComponent, Object.assign({}, this.state.year, {
                change: this.changeYear,
                legend: 'Anläggningsår',
                min: [0, 0],
                placeholder: ['Årtal', 'Årtal']
            })),
            h('label', [
                h('input', {
                    type: 'checkbox',
                    checked: this.state.includeMissingValues,
                    onClick: evt => this.setState({includeMissingValues: evt.target.checked})
                }),
                'Inkludera dammar med saknade värden'
            ]),
            h('div.button-bar', [
                h('button.button.gradient', [
                    'Filtrera'
                ])
            ])
        ]);
    }
}

const ModeSwitcherComponent = observer(() => {
    const mode = STATE.mode;
    
    return [
        h(ModeSwitcher),
        h('hr'),
        h(LakeMapsComponent, { visible: mode === 'lake' }),
        h(DamFilterComponent, { visible: mode === 'dam' })
    ];
})

export { ModeSwitcherComponent };
